import { VehicleTemplatesService, type PostPutVehicleTemplateRequestAdmin } from '@/backend/market'
import { VehicleTemplateRepository } from '../../domain/repositories/VehicleTemplateRepository'
import { VehicleTemplateModel } from '../models/VehicleTemplateModel'
import { VehicleFilterModel } from '../models/VehicleFilterModel'
import type { CreateUpdateVehicleTemplateEntity } from '../../domain/entities/CreateUpdateVehicleTemplateEntity'
import { CreateUpdateVehicleTemplateModel } from '../models/CreateUpdateVehicleTemplateModel'
import type { VehicleTemplateEntity } from '../../domain/entities/VehicleTemplateEntity'
import type { VehicleTemplateFilterEntity } from '../../domain/entities/VehicleTemplateFilterEntity'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'

export class VehicleTemplateRepositoryImpl implements VehicleTemplateRepository {
  async getVehicleTemplates(
    filterData: VehicleTemplateFilterEntity
  ): Promise<PaginateEntity<VehicleTemplateEntity[]> | { error: true }> {
    const vehicleFilterModel = new VehicleFilterModel(filterData)

    try {
      const response = await VehicleTemplatesService.getVehicleTemplatesAdmin(
        vehicleFilterModel as {}
      )

      const vehicleTemplateModel = response.items?.map((item) => new VehicleTemplateModel(item))
      const result = new PaginateEntity<VehicleTemplateModel[]>(response, vehicleTemplateModel)

      return result
    } catch {
      return { error: true }
    }
  }
  async getVehicleTemplate(id: number): Promise<VehicleTemplateEntity | { error: true }> {
    try {
      const response = await VehicleTemplatesService.getVehicleTemplateAdmin({
        id
      })
      const vehicleTemplateModel = new VehicleTemplateModel(response)

      return vehicleTemplateModel
    } catch {
      return { error: true }
    }
  }
  async createVehicleTemplate(
    vehcileData: CreateUpdateVehicleTemplateEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateVehicleTemplateModel = new CreateUpdateVehicleTemplateModel(vehcileData)
    try {
      await VehicleTemplatesService.postVehicleTemplateAdmin({
        requestBody:
          createUpdateVehicleTemplateModel as unknown as PostPutVehicleTemplateRequestAdmin
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateVehicleTemplate(
    id: number,
    vehcileData: CreateUpdateVehicleTemplateEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateVehicleTemplateModel = new CreateUpdateVehicleTemplateModel(vehcileData)
    try {
      await VehicleTemplatesService.putVehicleTemplateAdmin({
        id,
        requestBody:
          createUpdateVehicleTemplateModel as unknown as PostPutVehicleTemplateRequestAdmin
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteVehicleTemplate(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await VehicleTemplatesService.deleteVehicleTemplateAdmin({
        id
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
